import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead } from './SectionHead';
import { UnorderedListOutlined } from '@ant-design/icons';

// The section subtitle names where its cards come from: a card without `source` is from the service documents
export const statusSubKey = cards => {
    const fromInspection = cards.filter(card => card.source === 'inspection').length;
    if (!fromInspection) return 'status.sub';
    return fromInspection === cards.length ? 'status.subInspection' : 'status.subBoth';
};

// `stacked`: one card per row, for the narrow side column
export const StatusCards = ({ cards, stacked = false }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section
            id="status"
            className={`card${stacked ? ' side-card' : ''}`}
            aria-labelledby="status-title"
            style={{ gap: 16 }}
        >
            <SectionHead
                id="status-title"
                icon={UnorderedListOutlined}
                title={t('status.title')}
                sub={t(statusSubKey(cards))}
            />
            <div className={`stgrid${stacked ? ' stacked' : ''}`}>
                {cards.map(card => (
                    <article className={`st st-${card.tone}`} key={card.label}>
                        <span className="eyebrow">{card.label}</span>
                        <span className="st-v">{card.value}</span>
                        {card.sub && <span className="st-sub">{card.sub}</span>}
                    </article>
                ))}
            </div>
        </section>
    );
};
